import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { TabId } from "@/marketing/models/influencer";

interface ListStore {
  activeListId: string | null;
  activeTab: TabId;

  setActiveList: (id: string) => void;
  setActiveTab: (tab: TabId) => void;
}

export const useListStore = create<ListStore>()(
  persist(
    (set) => ({
      activeListId: null,
      activeTab: "discover",

      setActiveList: (id) => set({ activeListId: id }),
      setActiveTab: (tab) => set({ activeTab: tab }),
    }),
    {
      name: "influencer-lists",
    },
  ),
);
